<nav class="navbar d-print-none">
  <span class="navbar-brand">Meetings</span>
  <span class="mx-auto"></span>
  <ng-container *ngIf="selectedIndex < 0">
    <div class="d-print-none btn-group" role="group">
      <button type="button" class="btn btn-outline-success" ngbTooltip="Create a new meeting" (click)="newMeeting()">
        <span class="fa fa-plus">&nbsp;</span></button>
      <div ngbDropdown class="btn-group" aria-label="Copy from previous meeting"
           ngbTooltip="Create a new meeting from a previous date">
        <button type="button" ngbDropdownToggle class="btn btn-outline-success"><span
          class="ms-1 fa fa-copy">&nbsp;</span></button>
        <div class="dropdown-menu" ngbDropdownMenu>
          <ng-container *ngFor="let m of meetings">
            <button type="button" class="dropdown-item" (click)="copyMeeting(m)">{{ m.date | date:'shortDate' }}
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="selectedIndex > -1">
    <button-close btnClass="btn-sm" (btnClick)="closeMeeting()"></button-close>
  </ng-container>
</nav>
<ng-container *ngIf="selectedIndex < 0">
  <div class="d-print-none p-3 pe-5">
    <sortable-table [showDelete]="true" [showMore]="true" [data]="meetings" [headers]="headers"
                    (moreCall)="open($event)" (delCall)="delete($event)" defaultSort="date"
                    [ngClass]="{'meeting-selected' : selectedIndex > -1}" class="d-print-none"></sortable-table>
  </div>
</ng-container>

<ng-container *ngFor="let m of meetings">
  <div class="p-3 pe-5 d-none d-print-block">
    <student-meeting [meeting]="m"
                     [districtId]="districtId" [studentId]="studentId"
                     [meeting_topics]="topics"
                     [meeting_nextsteps]="nextsteps" [meeting_problems]="problems"
                     [meeting_strcons]="strcons"></student-meeting>
  </div>
</ng-container>
<ng-container *ngIf="selectedIndex > -1">
  <div class="d-print-none p-3 pe-5 ">
    <student-meeting #openMeeting
                     [(meeting)]="meetings[selectedIndex]" [studentId]="studentId"
                     [districtId]="districtId" [meeting_topics]="topics" [editing]="editing"
                     [meeting_nextsteps]="nextsteps" [meeting_problems]="problems"
                     [meeting_strcons]="strcons" [meetings]="meetings">
    </student-meeting>
  </div>
</ng-container>
